export default __webpack_public_path__ + "img/spotify_hover.15a767dffb77d6ce81385ad5ccb3188a.svg";